import { createStyles } from 'antd-style';
import React from 'react';

interface BrandSiderHeaderProps {
  logoSrc?: string;
  logoAlt?: string;
  title?: string;
  subtitle?: string;
  collapsed?: boolean;
}

const useStyles = createStyles(({ token, css }) => {
  return {
    root: css`
      width: 100%;
      padding: 16px 16px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 48px;
      background: #f7f7f8;
    `,
    rootCollapsed: css`
      justify-content: center;
      padding-inline: 8px;
    `,
    brandBlock: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      width: 100%;
    `,
    compactMark: css`
      width: 32px;
      height: 32px;
      border-radius: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: transparent;
      overflow: hidden;
    `,
    compactLogo: css`
      width: 20px;
      height: 20px;
      object-fit: contain;
      display: block;
    `,
    fallbackMark: css`
      font-size: 16px;
      line-height: 1;
      font-weight: 600;
      color: ${token.colorTextHeading};
      letter-spacing: -0.01em;
    `,
    expandedLogo: css`
      display: block;
      width: 100%;
      max-width: 136px;
      max-height: 26px;
      margin: 0 auto;
      object-fit: contain;
      object-position: center center;
    `,
    subtitle: css`
      font-size: 14px;
      line-height: 1.2;
      font-weight: 400;
      color: #000000;
      text-align: center;
      white-space: nowrap;
    `,
    title: css`
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: ${token.colorTextHeading};
      letter-spacing: -0.01em;
      text-align: center;
    `,
  };
});

const BrandSiderHeader: React.FC<BrandSiderHeaderProps> = ({
  logoSrc,
  logoAlt,
  title = 'Dossm Hospitality AI Video Platform',
  subtitle = '文旅AI创意短视频生成平台',
  collapsed = false,
}) => {
  const { styles, cx } = useStyles();
  const fallbackMark = title.trim().charAt(0).toUpperCase() || 'A';

  if (collapsed) {
    return (
      <div className={cx(styles.root, styles.rootCollapsed)}>
        <div className={styles.compactMark}>
          {logoSrc ? (
            <img src={logoSrc} alt={logoAlt || title} className={styles.compactLogo} />
          ) : (
            <span className={styles.fallbackMark}>{fallbackMark}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.brandBlock}>
        {logoSrc ? (
          <img src={logoSrc} alt={logoAlt || title} className={styles.expandedLogo} />
        ) : (
          <span className={styles.title}>{title}</span>
        )}
        {/**
         * 展开态需要在品牌主标识下方补充固定副标题，帮助用户在侧边栏入口
         * 直接识别当前站点的视频平台定位；折叠态不渲染，避免挤压窄栏宽度。
         */}
        <span className={styles.subtitle}>{subtitle}</span>
      </div>
    </div>
  );
};

export default BrandSiderHeader;
